

export interface MajorVersionModel{
    Version:string,
    LastUpdated:Date,
    Details:VersionSummaryModel[]
}

export interface VersionSummaryModel{
    Version:string,
    Updated:Date,
    UpdatedBy:string,
    Description:string,
    Remarks:string
}

export enum TableStatsTypes{
    MagneticTable,
    MagneticOutputTable,
    ITSOTable,
    ITSOOutputTable
}

export interface TableStats{
    TotalTableCount:number
}

